import React from "react";
import "../css/aviso-obras-web.css";

const AvisoObrasWeb = () => (
  <div className="aviso-obras-web">
    <div className="aviso-contenido">
      <span role="img" aria-label="herramientas" className="aviso-emoji">🚧</span>
      <div>
        <h3>¡Nueva Web en Construcción!</h3>
        <p>
          Estamos mejorando nuestra Web para brindarte una mejor experiencia.<br />
          En las proximas horas estará disponible esta información.
        </p>
      </div>
    </div>
  </div>
);

export default AvisoObrasWeb;